import _ from 'lodash';
import c from 'common/constants/flux-events';
import findCacheState from 'utils/find-cache-state';

const initialState = {
    items: [
        {
            type: 'overview',
            id: _.uniqueId('date_'),
            groupings: ['date'],
            serverName: '',
        },
    ],
};

export default function(state = {}, action) {
    switch (action.type) {
        case c.CAMPAIGN_REPORT__INIT_STATE: {
            const { campaignId } = action.payload;

            return findCacheState(campaignId, state, initialState);
        }
        case c.CAMPAIGN_REPORT__INITIALIZE: {
            const { campaign, isClient, isClientReportPage } = action.payload;

            const sharingSettings = _.get(
                campaign,
                'sharing_settings.report_tabs.explore.dimensions',
                []
            );

            const items = initialState.items;

            const nextItems = items.filter(config => {
                if (_.includes(['pivot', 'overview', 'scope'], config.type)) {
                    // We always want these components
                    return true;
                }

                // This is where we enforce campaign sharing settings on dimensions.
                // We do the same for metrics in the metricSelector
                const sharingConfig = _.find(sharingSettings, setting => {
                    return setting.name === config.serverName;
                });

                return isClient || isClientReportPage
                    ? _.get(sharingConfig, 'shared', false)
                    : true;
            });

            return {
                ...state,
                items: nextItems,
            };
        }

        case c.CAMPAIGN_REPORT__PIVOT_TABLE__SPLIT__ADD: {
            const { split } = action.payload;

            const nextItems = state.items.map(component => {
                if (component.type === 'pivot') {
                    return {
                        ...component,
                        groupings: _.uniq([].concat(component.groupings).concat(split.value)),
                    };
                } else {
                    return component;
                }
            });

            return {
                ...state,
                items: nextItems,
            };
        }

        case c.CAMPAIGN_REPORT__PIVOT_TABLE__SPLIT__REMOVE: {
            const { split } = action.payload;

            const nextItems = state.items.map(component => {
                if (component.type === 'pivot') {
                    return {
                        ...component,
                        groupings: _.without(component.groupings, split.value),
                    };
                } else {
                    return component;
                }
            });

            return {
                ...state,
                items: nextItems,
            };
        }

        case c.CAMPAIGN_REPORT__AVAILABLE_ADGROUPS__FETCH_SUCCESS: {
            const { campaign } = action.payload;

            const scopeComponents = campaign.customDimensions.map(scope => {
                return {
                    id: _.uniqueId(`${scope.id}_`),
                    title: scope.name,
                    type: 'scope',
                    groupings: [scope.id],
                };
            });

            const componentsWithoutScopes = state.items.filter(c => c.type !== 'scope');

            const nextItems = componentsWithoutScopes.concat(scopeComponents);

            return {
                ...state,
                items: nextItems,
            };
        }

        default:
            return state;
    }
}
